import regeneratorRuntime from "regenerator-runtime";
import { AssetsDoc, AssetsSDK, CollectiblesDoc, CollectiblesSDK, StoreDoc, StoreSDK, Uint, DMADoc, DMASDK, TokenWithdrawalDoc, TokenWithdrawalSDK } from '@delysium/core';
export * from '@delysium/core';
import { DeploymentInfo, getContractAddress, ContractName } from '@delysium/abi';
export * from '@delysium/abi';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Client = /*#__PURE__*/function () {
  function Client() {
    _classCallCheck(this, Client);

    _defineProperty(this, "_options", undefined);
  }

  _createClass(Client, [{
    key: "initialize",
    value:
    /**
     * Initialize the client with a wallet provider and a network
     * @param options
     */
    function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._options = options;
                return _context.abrupt("return", this.assignSigner());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
    /**
     *  Update SDK with a new Network when user is switching networks from his wallet
     *  SDK will fetch required smart-contract ABI for the desired new Network and re-initialize itself
     * @param network
     */

  }, {
    key: "syncNetwork",
    value: function syncNetwork(network) {
      this.options.network = network;
      return this.initialize(this.options);
    }
    /**
     * Update SDK with a new signer when user is switching accounts on his wallet
     * SDK will re-initialize itself
     */

  }, {
    key: "syncSigner",
    value: function syncSigner() {
      return this.assignSigner();
    }
  }, {
    key: "assignSigner",
    value: function () {
      var _assignSigner = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var signer;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                signer = this.options.provider.getSigner();
                return _context2.abrupt("return", signer.getAddress().then(function (address) {
                  _this.initializeSDK(signer);
                })["catch"](function (error) {
                  return Promise.reject("Cannot initialize @delysium/client, the user has not link his wallet yet: ".concat(error));
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function assignSigner() {
        return _assignSigner.apply(this, arguments);
      }

      return assignSigner;
    }()
  }, {
    key: "options",
    get: function get() {
      if (this._options === undefined) {
        throw new Error("options is not initialized.");
      } else {
        return this._options;
      }
    }
  }]);

  return Client;
}();

var isNull = function isNull(data) {
  return data === undefined || data === null;
};
var isNotNull = function isNotNull(data) {
  return !isNull(data);
};
var isEmpty = function isEmpty(data) {
  return isNull(data) || data === '' || Array.isArray(data) && data.length === 0;
};
var isNotEmpty = function isNotEmpty(data) {
  return !isEmpty(data);
};
var throwIfNull = function throwIfNull(data, exception) {
  if (isNull(data)) {
    throw exception;
  }
};

var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);
  }

  _createClass(Config, null, [{
    key: "generate",
    value: function generate(doc, deploymentInfo) {
      return {
        title: doc === null || doc === void 0 ? void 0 : doc.title,
        description: doc === null || doc === void 0 ? void 0 : doc.description,
        networks: this.generateNetworks(doc.contractName, deploymentInfo),
        methodGroups: doc.methodGroups,
        roles: doc.roles,
        formatError: doc === null || doc === void 0 ? void 0 : doc.formatError
      };
    }
  }, {
    key: "generateNetworks",
    value: function generateNetworks(contractName, deploymentInfo) {
      if (isNull(contractName)) {
        return [];
      }

      var result = [];
      Object.keys(deploymentInfo).map(function (key) {
        var config = deploymentInfo[key];
        var contracts = Object.keys(config.contracts).map(function (contractName) {
          return config.contracts[contractName];
        });

        if (isNotNull(config.contracts[contractName])) {
          result.push({
            name: config.network.name,
            key: key,
            chainId: config.network.chainId,
            currency: config.network.currency,
            rpc: config.network.rpc,
            contracts: contracts
          });
        }
      });
      return result;
    }
  }]);

  return Config;
}();

var ClientSDK = /*#__PURE__*/function (_Client) {
  _inherits(ClientSDK, _Client);

  var _super = _createSuper(ClientSDK);

  function ClientSDK(name, documentation, factory) {
    var _this;

    _classCallCheck(this, ClientSDK);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "_sdk", undefined);

    _this._name = name;
    _this._config = Config.generate(documentation, DeploymentInfo);
    _this._factory = factory;
    return _this;
  }

  _createClass(ClientSDK, [{
    key: "initializeSDK",
    value: function initializeSDK(signer) {
      this._sdk = _construct(this._factory, [signer].concat(_toConsumableArray(this.getContractAddresses())));
    }
  }, {
    key: "sdk",
    get: function get() {
      if (this._sdk === undefined) {
        throw new Error("SDK[".concat(this._name, "] is not initialized"));
      } else {
        return this._sdk;
      }
    }
  }, {
    key: "config",
    get: function get() {
      return this._config;
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return isNotNull(this._sdk);
    }
  }]);

  return ClientSDK;
}(Client);

var extractContractAddress = function extractContractAddress(contractName, network) {
  var networkInfo = getNetworkInfo(network);
  var config = networkInfo.contracts[contractName];
  throwIfNull(config, new Error("Contract not available for this network."));
  return getContractAddress(config);
};
var getNetworkInfo = function getNetworkInfo(network) {
  var info = DeploymentInfo[network];

  if (isNull(info)) {
    throw new Error("Network[".concat(network, "] is not supported."));
  }

  return info;
};

/**
 * DelysiumAssets API to manage tokens for DelysiumAssets[ERC721]
 */

var DelysiumAssets = /*#__PURE__*/function (_ClientSDK) {
  _inherits(DelysiumAssets, _ClientSDK);

  var _super = _createSuper(DelysiumAssets);

  function DelysiumAssets(contractAddress) {
    var _this;

    _classCallCheck(this, DelysiumAssets);

    _this = _super.call(this, ContractName.assets, AssetsDoc, AssetsSDK);
    _this._address = contractAddress;
    return _this;
  }

  _createClass(DelysiumAssets, [{
    key: "getContractAddresses",
    value: function getContractAddresses() {
      var address = isNotEmpty(this._address) ? this._address : extractContractAddress(ContractName.assets, this.options.network);
      return [address];
    }
  }, {
    key: "updateContractAddress",
    value: function () {
      var _updateContractAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(address) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._address = address;
                return _context.abrupt("return", this.syncSigner());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateContractAddress(_x) {
        return _updateContractAddress.apply(this, arguments);
      }

      return updateContractAddress;
    }()
  }]);

  return DelysiumAssets;
}(ClientSDK);

/**
 * DelysiumCollectibles API to manage airdrop, market, administration functionalities for DelysiumCollectibles[ERC1155]
 */

var DelysiumCollectibles = /*#__PURE__*/function (_ClientSDK) {
  _inherits(DelysiumCollectibles, _ClientSDK);

  var _super = _createSuper(DelysiumCollectibles);

  function DelysiumCollectibles(contractAddress) {
    var _this;

    _classCallCheck(this, DelysiumCollectibles);

    _this = _super.call(this, ContractName.collectibles, CollectiblesDoc, CollectiblesSDK);
    _this._address = contractAddress;
    return _this;
  }

  _createClass(DelysiumCollectibles, [{
    key: "getContractAddresses",
    value: function getContractAddresses() {
      var address = isNotEmpty(this._address) ? this._address : extractContractAddress(ContractName.collectibles, this.options.network);
      return [address];
    }
  }, {
    key: "updateContractAddress",
    value: function () {
      var _updateContractAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(address) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._address = address;
                return _context.abrupt("return", this.syncSigner());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateContractAddress(_x) {
        return _updateContractAddress.apply(this, arguments);
      }

      return updateContractAddress;
    }()
  }]);

  return DelysiumCollectibles;
}(ClientSDK);

/**
 * DelysiumStore API to manage tokens for DelysiumStore[ERC721]
 */

var DelysiumStore = /*#__PURE__*/function (_ClientSDK) {
  _inherits(DelysiumStore, _ClientSDK);

  var _super = _createSuper(DelysiumStore);

  function DelysiumStore() {
    var _this;

    var storeAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var assetAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, DelysiumStore);

    _this = _super.call(this, ContractName.store, StoreDoc, StoreSDK);
    _this._storeAddress = storeAddress;
    _this._assetAddress = assetAddress;
    return _this;
  }

  _createClass(DelysiumStore, [{
    key: "getContractAddresses",
    value: function getContractAddresses() {
      var storeAddress = isNotEmpty(this._storeAddress) ? this._storeAddress : extractContractAddress(ContractName.store, this.options.network);
      var assetAddress = isNotEmpty(this._assetAddress) ? this._assetAddress : extractContractAddress(ContractName.assets, this.options.network);
      return [storeAddress, assetAddress];
    }
  }, {
    key: "updateContractAddress",
    value: function () {
      var _updateContractAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(storeAddress, assetAddress) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._storeAddress = storeAddress;
                this._assetAddress = assetAddress;
                return _context.abrupt("return", this.syncSigner());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateContractAddress(_x, _x2) {
        return _updateContractAddress.apply(this, arguments);
      }

      return updateContractAddress;
    }()
  }]);

  return DelysiumStore;
}(ClientSDK);

/**
 * Marketplace API combining market functionalities of DelysiumCollectibles[1155] and DelysiumAssets[721]
 * - using DelysiumCollectibles SDK to manage market functionalities for DelysiumCollectibles[ERC1155]
 * - using DelysiumStore SDK to manage market functionalities for DelysiumAssets[ERC721]
 */

var Marketplace = /*#__PURE__*/function (_Client) {
  _inherits(Marketplace, _Client);

  var _super = _createSuper(Marketplace);

  function Marketplace() {
    var _this;

    var storeAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var assetAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var collectiblesAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    _classCallCheck(this, Marketplace);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "_collectibles", undefined);

    _defineProperty(_assertThisInitialized(_this), "_store", undefined);

    _this._storeAddress = storeAddress;
    _this._assetAddress = assetAddress;
    _this._collectiblesAddress = collectiblesAddress;
    return _this;
  }

  _createClass(Marketplace, [{
    key: "initializeSDK",
    value: function initializeSDK(signer) {
      this._collectibles = new CollectiblesSDK(signer, extractContractAddress(ContractName.collectibles, this.options.network));
      this._store = new StoreSDK(signer, extractContractAddress(ContractName.store, this.options.network), extractContractAddress(ContractName.assets, this.options.network));
    }
  }, {
    key: "hasSupply",
    value: function () {
      var _hasSupply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contract, tokenId, quantity) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Uint.validate(tokenId);
                _context.t0 = contract.toLowerCase();
                _context.next = _context.t0 === this.collectibles.contractAddress.toLowerCase() ? 4 : _context.t0 === this.store.contractAddress.toLowerCase() ? 5 : 6;
                break;

              case 4:
                return _context.abrupt("return", this.collectibles.hasSupply(tokenId, quantity));

              case 5:
                return _context.abrupt("return", this.store.hasSupply(tokenId, quantity));

              case 6:
                return _context.abrupt("return", Promise.reject("Unknown contract [".concat(contract, "]. Marketplace support [").concat(this.collectibles.contractAddress, ", ").concat(this.store.contractAddress, "]")));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function hasSupply(_x, _x2, _x3) {
        return _hasSupply.apply(this, arguments);
      }

      return hasSupply;
    }()
  }, {
    key: "preOrder",
    value: function () {
      var _preOrder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(contract, tokenId, quantity) {
        var statusEvent,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                statusEvent = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : undefined;
                Uint.validate(tokenId);
                _context2.t0 = contract.toLowerCase();
                _context2.next = _context2.t0 === this.collectibles.contractAddress.toLowerCase() ? 5 : _context2.t0 === this.store.contractAddress.toLowerCase() ? 6 : 7;
                break;

              case 5:
                return _context2.abrupt("return", this.collectibles.preOrder(tokenId, quantity, statusEvent));

              case 6:
                return _context2.abrupt("return", this.store.preOrder(tokenId, quantity, statusEvent));

              case 7:
                return _context2.abrupt("return", Promise.reject("Unknown contract [".concat(contract, "]. Marketplace support [").concat(this.collectibles.contractAddress, ", ").concat(this.store.contractAddress, "]")));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function preOrder(_x4, _x5, _x6) {
        return _preOrder.apply(this, arguments);
      }

      return preOrder;
    }()
  }, {
    key: "buy",
    value: function () {
      var _buy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(contract, tokenId, quantity) {
        var statusEvent,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                statusEvent = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : undefined;
                Uint.validate(tokenId);
                _context3.t0 = contract.toLowerCase();
                _context3.next = _context3.t0 === this.collectibles.contractAddress.toLowerCase() ? 5 : _context3.t0 === this.store.contractAddress.toLowerCase() ? 6 : 7;
                break;

              case 5:
                return _context3.abrupt("return", this.collectibles.buy(tokenId, quantity, statusEvent));

              case 6:
                return _context3.abrupt("return", this.store.buy(tokenId, quantity, statusEvent));

              case 7:
                return _context3.abrupt("return", Promise.reject("Unknown contract [".concat(contract, "]. Marketplace support [").concat(this.collectibles.contractAddress, ", ").concat(this.store.contractAddress, "]")));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function buy(_x7, _x8, _x9) {
        return _buy.apply(this, arguments);
      }

      return buy;
    }()
  }, {
    key: "store",
    get: function get() {
      if (this._store === undefined) {
        throw new Error("DelysiumStore is not initialized");
      } else {
        return this._store;
      }
    }
  }, {
    key: "collectibles",
    get: function get() {
      if (this._collectibles === undefined) {
        throw new Error("DelysiumCollectibles is not initialized");
      } else {
        return this._collectibles;
      }
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return isNotNull(this._store) && isNotNull(this._collectibles);
    }
  }]);

  return Marketplace;
}(Client);

/**
 * DelysiumDMA API to manage airdrop, market, administration functionalities for DelysiumDMA[Custom]
 */

var DMA = /*#__PURE__*/function (_ClientSDK) {
  _inherits(DMA, _ClientSDK);

  var _super = _createSuper(DMA);

  function DMA(contractAddress) {
    var _this;

    _classCallCheck(this, DMA);

    _this = _super.call(this, ContractName.dma, DMADoc, DMASDK);
    _this._address = contractAddress;
    return _this;
  }

  _createClass(DMA, [{
    key: "getContractAddresses",
    value: function getContractAddresses() {
      var address = isNotEmpty(this._address) ? this._address : extractContractAddress(ContractName.dma, this.options.network);
      return [address];
    }
  }, {
    key: "updateContractAddress",
    value: function () {
      var _updateContractAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(address) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._address = address;
                return _context.abrupt("return", this.syncSigner());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateContractAddress(_x) {
        return _updateContractAddress.apply(this, arguments);
      }

      return updateContractAddress;
    }()
  }]);

  return DMA;
}(ClientSDK);

/**
 * Delysium Withdrawal API to manage withdraw and moderator functionalities for TokenWithdrawal[Custom] which is a token bank contract
 */

var TokenWithdrawal = /*#__PURE__*/function (_ClientSDK) {
  _inherits(TokenWithdrawal, _ClientSDK);

  var _super = _createSuper(TokenWithdrawal);

  function TokenWithdrawal(contractAddress) {
    var _this;

    _classCallCheck(this, TokenWithdrawal);

    _this = _super.call(this, ContractName.tokenWithdrawal, TokenWithdrawalDoc, TokenWithdrawalSDK);
    _this._address = contractAddress;
    return _this;
  }

  _createClass(TokenWithdrawal, [{
    key: "getContractAddresses",
    value: function getContractAddresses() {
      var address = isNotEmpty(this._address) ? this._address : extractContractAddress(ContractName.tokenWithdrawal, this.options.network);
      return [address];
    }
  }, {
    key: "updateContractAddress",
    value: function () {
      var _updateContractAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(address) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._address = address;
                return _context.abrupt("return", this.syncSigner());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateContractAddress(_x) {
        return _updateContractAddress.apply(this, arguments);
      }

      return updateContractAddress;
    }()
  }]);

  return TokenWithdrawal;
}(ClientSDK);

export { DMA, DelysiumAssets, DelysiumCollectibles, DelysiumStore, Marketplace, TokenWithdrawal };
